import { render } from "./kalio-image-input.vue?vue&type=template&id=55e6b58d"
import script from "./kalio-image-input.vue?vue&type=script&lang=js"
export * from "./kalio-image-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__